<template>
  <NewsPage />
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import NewsPage from '@/components/News.vue'

export default {
  name: 'Recipe',
  components: {
    // HelloWorld
    NewsPage
  }
}
</script>
